import {ExcelExportService} from '../../services/excel-export.service';
import {AfterViewInit, OnDestroy} from '@angular/core';
import {Subscription} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {VeritiyPricesTableRowModel} from '../../../prices-view/models/verity-prices-table-row-model';
import {ServiceLocator} from '../../services/ServiceLocator';
import {CurrencyConverterPipe} from '../../pipes/currency-converter.pipe';
import {Utils} from '../../services/utils';
import {DatePipe} from '@angular/common';
import {TableViewService} from '../table-view/table-view.service';
import {TableChartState} from '../../../prices-view/components/verity-prices-table/table-chart-state';

export abstract class ExporterComponent implements AfterViewInit, OnDestroy {
  private exportSubscription: Subscription;

  protected exportService: ExcelExportService;
  protected http: HttpClient;
  protected currencyConverterPipe: CurrencyConverterPipe;
  protected datePipe: DatePipe;
  protected tableViewService: TableViewService;

  tableColumns: VeritiyPricesTableRowModel[] = [];
  tableInput: any[] = [];

  public constructor() {
    this.http = ServiceLocator.injector.get(HttpClient);
    this.exportService = ServiceLocator.injector.get(ExcelExportService);
    this.currencyConverterPipe = ServiceLocator.injector.get(CurrencyConverterPipe);
    this.datePipe = ServiceLocator.injector.get(DatePipe);
    this.tableViewService = ServiceLocator.injector.get(TableViewService);
    this.exportService.isExportAvailable = this.isExportAvailable();
  }

  ngAfterViewInit(): void {
    this.exportSubscription = this.exportService.onExportPressed
      .subscribe(() => this.onExportClicked());
  }

  ngOnDestroy(): void {
    if (this.exportSubscription) {
      this.exportSubscription.unsubscribe();
    }
  }

  private onExportClicked() {
    const body = this.buildExportData();
    if (this.tableViewService.tableChartState === TableChartState.CHART) {
      body['view'] = 'graph';
    }

    this.http.post(this.getExportUrl(), body, {responseType: 'blob'})
      .subscribe(response => {

        const dateString = this.datePipe.transform(new Date(), 'MMddyyyy_HHmm');

        Utils.downLoadFile(response,
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'Verity_Export_' + dateString + '.xlsx');
      });
  }


  abstract buildExportData(): any;

  abstract getExportUrl(): string;

  abstract isExportAvailable(): boolean;
}
